import React from 'react';
import { useSelector } from '../data/store';
import { resolveTabs, type SegmentTab } from './DossierRightPane/tabs';

export function useDossierTabs(dossierId: string | null): {
  tabs: SegmentTab[];
  ready: boolean;
} {
  const claim = useSelector((s) =>
    dossierId ? s['claim-overview'].claimMetadata[dossierId] ?? null : null
  );
  const failed = useSelector(
    (s) => s['claim-overview'].actions.fetchClaim.status === 'rejected'
  );

  return React.useMemo(
    () => ({ tabs: resolveTabs(claim?.tabs), ready: claim !== null || failed }),
    [claim, failed]
  );
}
